var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("van-icon", {
          staticClass: "header-return",
          attrs: { name: "arrow-left", size: "25", color: "#ffffff" },
          on: {
            click: function($event) {
              return _vm.onClickHeaderReturn()
            }
          }
        }),
        _vm._v("\n    Current Settings\n  ")
      ],
      1
    ),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "setting-model" }, [
        _c(
          "button",
          {
            staticClass: "model-button",
            class:
              _vm.selectModel === "Wave Writer" ? "model-button-active" : "",
            staticStyle: { "margin-right": "8px" },
            on: {
              click: function($event) {
                return _vm.onClickSelectModel("Wave Writer")
              }
            }
          },
          [_vm._v("\n        Wave Writer\n      ")]
        ),
        _c(
          "button",
          {
            staticClass: "model-button",
            class: _vm.selectModel === "Device" ? "model-button-active" : "",
            staticStyle: { "margin-left": "8px" },
            on: {
              click: function($event) {
                return _vm.onClickSelectModel("Device")
              }
            }
          },
          [_vm._v("\n        Device\n      ")]
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectModel === "Wave Writer",
              expression: "selectModel === 'Wave Writer'"
            }
          ],
          staticStyle: { "overflow-y": "auto" }
        },
        [
          _vm.hubOutputMode === 0 ||
          _vm.hubOutputMode === 0x10 ||
          _vm.hubOutputMode === 0x20
            ? _c("div", [
                _c("div", { staticClass: "info-item" }, [
                  _c("div", { staticClass: "info-title" }, [
                    _vm._v("Hub Info")
                  ]),
                  _c("div", { staticClass: "item-split" }),
                  _c(
                    "div",
                    { staticClass: "info-content" },
                    [
                      _c("InfoRow", {
                        attrs: { left: "Device Model", right: "VIA hub" }
                      }),
                      _c("InfoRow", {
                        attrs: {
                          left: "S/N",
                          right: _vm.macAddress.replace(/:/g, "")
                        }
                      })
                    ],
                    1
                  )
                ]),
                false
                  ? _c("div", { staticClass: "info-item" }, [
                      _c(
                        "div",
                        { staticClass: "info-title" },
                        [
                          _vm._v("\n            Preheat\n            "),
                          _c("van-switch", {
                            staticStyle: { "margin-left": "auto" },
                            attrs: {
                              "active-color": "#66DCA5",
                              "inactive-color": "#D6CDF2",
                              size: "18",
                              disabled: true
                            },
                            model: {
                              value: _vm.hubSetting.isSupportPreheat,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.hubSetting,
                                  "isSupportPreheat",
                                  $$v
                                )
                              },
                              expression: "hubSetting.isSupportPreheat"
                            }
                          })
                        ],
                        1
                      ),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false"
                          }
                        ],
                        staticClass: "item-split"
                      }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: false,
                              expression: "false"
                            }
                          ],
                          staticClass: "info-content"
                        },
                        [
                          _c("InfoRow", {
                            attrs: {
                              left: "Time",
                              right:
                                (_vm.hubSetting.preheatTime / 1000).toFixed(1) +
                                "s"
                            }
                          }),
                          _c("InfoRow", {
                            attrs: {
                              left: "Voltage",
                              right:
                                (_vm.hubSetting.preheatVoltage / 1000).toFixed(
                                  1
                                ) + "v"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _c("div", { staticClass: "info-item" }, [
                  _c("div", { staticClass: "info-title" }, [
                    _vm._v("Voltage Curve")
                  ]),
                  _c("div", { staticClass: "item-split" }),
                  _c("div", { staticClass: "info-content" }, [
                    _c(
                      "div",
                      { staticClass: "voltage-one" },
                      _vm._l(
                        _vm.hubVoltage.slice(0, _vm.voltageCount),
                        function(item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "voltage-number" },
                            [
                              _vm.hubOutputMode === 0x20
                                ? _c("span", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          Math.abs(item / 100).toFixed(1)
                                        ) +
                                        " " +
                                        _vm._s(_vm.hubInfo.unitName) +
                                        "\n                "
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          Math.abs(item / 1000).toFixed(1)
                                        ) +
                                        "\n                  " +
                                        _vm._s(_vm.hubInfo.unitName) +
                                        "\n                "
                                    )
                                  ])
                            ]
                          )
                        }
                      ),
                      0
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "voltage-two",
                        staticStyle: { width: "100%", height: "calc(20vh)" },
                        attrs: { id: "voltageTwo" }
                      },
                      _vm._l(
                        _vm.hubVoltage.slice(0, _vm.voltageCount),
                        function(value, index) {
                          return _c("van-slider", {
                            key: index,
                            attrs: {
                              vertical: "",
                              min: _vm.hubInfo.dragValue.max,
                              max: _vm.hubInfo.dragValue.min,
                              step: _vm.hubInfo.dragValue.step,
                              "bar-height": "4px",
                              "active-color": "#EEEEEE",
                              "inactive-color": "#D6CDF2",
                              disabled: true
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "button",
                                  fn: function() {
                                    return [
                                      _c("img", {
                                        staticClass: "slider-button",
                                        attrs: {
                                          src: require("@/assets/icons/icon_slider_button_disabled.png")
                                        }
                                      })
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            ),
                            model: {
                              value: _vm.hubVoltage[index],
                              callback: function($$v) {
                                _vm.$set(_vm.hubVoltage, index, $$v)
                              },
                              expression: "hubVoltage[index]"
                            }
                          })
                        }
                      ),
                      1
                    ),
                    false
                      ? _c(
                          "div",
                          { staticClass: "voltage-three" },
                          _vm._l(_vm.voltageCount, function(index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "voltage-number" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(index) +
                                    "s\n              "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                ])
              ])
            : _vm.hubOutputMode === 0x40
            ? _c("div", [
                _c("div", { staticClass: "info-item" }, [
                  _c("div", { staticClass: "info-title" }, [
                    _vm._v("Hub Info " + _vm._s(_vm.supportTripleCartridge))
                  ]),
                  _c("div", { staticClass: "item-split" }),
                  _vm.supportTripleCartridge
                    ? _c(
                        "div",
                        { staticClass: "info-content" },
                        [
                          _c("InfoRow", {
                            attrs: { left: "Device Model", right: "VIA hub" }
                          }),
                          _c("InfoRow", {
                            attrs: {
                              left: "S/N",
                              right: _vm.macAddress.replace(/:/g, "")
                            }
                          }),
                          _vm.showInfoIfExistsR1
                            ? _c("InfoRow", {
                                attrs: {
                                  left: "Push Power",
                                  right: `${_vm.hubSetting.micSensitivity.toFixed(
                                    2
                                  )}W`
                                }
                              })
                            : _vm._e(),
                          _c("InfoRow", {
                            attrs: { left: _vm.r1Title, right: `${_vm.r1}Ω` }
                          }),
                          _vm.showInfoIfExistsR1
                            ? _c("InfoRow", {
                                attrs: {
                                  left: _vm.r2Title,
                                  right: _vm.hubR2Value
                                }
                              })
                            : _vm._e(),
                          _vm.showInfoIfExistsR1
                            ? _c("InfoRow", {
                                attrs: {
                                  left: "Temperature",
                                  right: `${_vm.calcT2(
                                    _vm.r1,
                                    _vm.hubLeftR2 / 1000
                                  )}°C`
                                }
                              })
                            : _vm._e(),
                          _vm.showInfoIfExistsDoubleR1Triple
                            ? _c("InfoRow", {
                                attrs: {
                                  left: _vm.centerR1Title,
                                  right: `${_vm.centerR1}Ω`
                                }
                              })
                            : _vm._e(),
                          _vm.showInfoIfExistsDoubleR1Triple
                            ? _c("InfoRow", {
                                attrs: {
                                  left: _vm.centerR2Title,
                                  right: `${(
                                    _vm.tripleHubCenterR2 / 1000 +
                                    _vm.centerR1
                                  ).toFixed(3)}Ω`
                                }
                              })
                            : _vm._e(),
                          _vm.showInfoIfExistsDoubleR1Triple
                            ? _c("InfoRow", {
                                attrs: {
                                  left: "Temperature",
                                  right: `${_vm.calcT2(
                                    _vm.centerR1,
                                    _vm.tripleHubCenterR2 / 1000
                                  )}°C`
                                }
                              })
                            : _vm._e(),
                          _vm.showInfoIfExistsDoubleR1Triple
                            ? _c("InfoRow", {
                                attrs: {
                                  left: _vm.doubleR1Title,
                                  right: `${_vm.rightR1}Ω`
                                }
                              })
                            : _vm._e(),
                          _vm.showInfoIfExistsDoubleR1Triple
                            ? _c("InfoRow", {
                                attrs: {
                                  left: _vm.doubleR2Title,
                                  right: `${(
                                    _vm.tripleHubRightR2 / 1000 +
                                    _vm.rightR1
                                  ).toFixed(3)}Ω`
                                }
                              })
                            : _vm._e(),
                          _vm.showInfoIfExistsDoubleR1Triple
                            ? _c("InfoRow", {
                                attrs: {
                                  left: "Temperature",
                                  right: `${_vm.calcT2(
                                    _vm.rightR1,
                                    _vm.tripleHubRightR2 / 1000
                                  )}°C`
                                }
                              })
                            : _vm._e(),
                          !_vm.showInfoIfExistsR1
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "16px",
                                    "font-weight": "bold"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Please Read device to get base r\n            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _c("div", [
                        _c(
                          "div",
                          { staticClass: "info-content" },
                          [
                            _c("InfoRow", {
                              attrs: { left: "Device Model", right: "VIA hub" }
                            }),
                            _c("InfoRow", {
                              attrs: {
                                left: "S/N",
                                right: _vm.macAddress.replace(/:/g, "")
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "info-content" },
                          [
                            _vm.showInfoIfExistsR1
                              ? _c("InfoRow", {
                                  attrs: {
                                    left: "Push Power",
                                    right: `${(
                                      _vm.hubSetting.diyVoltage[2] / 100
                                    ).toFixed(2)}W`
                                  }
                                })
                              : _vm._e(),
                            _c("InfoRow", {
                              attrs: { left: _vm.r1Title, right: `${_vm.r1}Ω` }
                            }),
                            _vm.showInfoIfExistsR1
                              ? _c("InfoRow", {
                                  attrs: {
                                    left: _vm.r2Title,
                                    right: _vm.hubR2Value
                                  }
                                })
                              : _vm._e(),
                            _vm.showInfoIfExistsR1
                              ? _c("InfoRow", {
                                  attrs: {
                                    left: "Temperature1",
                                    right: `${_vm.calcT2(
                                      _vm.r1,
                                      _vm.hubLeftR2 / 1000
                                    )}°C`
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "info-content" },
                          [
                            _vm.showInfoIfExistsDoubleR1
                              ? _c("InfoRow", {
                                  attrs: {
                                    left: "Push Power",
                                    right: `${(
                                      _vm.hubSetting.diyVoltage[5] / 100
                                    ).toFixed(2)}W`
                                  }
                                })
                              : _vm._e(),
                            _vm.showInfoIfExistsDoubleR1
                              ? _c("InfoRow", {
                                  attrs: {
                                    left: _vm.doubleR1Title,
                                    right: `${_vm.doubleR1}Ω`
                                  }
                                })
                              : _vm._e(),
                            _vm.showInfoIfExistsDoubleR1
                              ? _c("InfoRow", {
                                  attrs: {
                                    left: _vm.doubleR2Title,
                                    right: `${(
                                      _vm.hubRightR2 / 1000 +
                                      _vm.doubleR1
                                    ).toFixed(3)}Ω`
                                  }
                                })
                              : _vm._e(),
                            _vm.showInfoIfExistsDoubleR1
                              ? _c("InfoRow", {
                                  attrs: {
                                    left: "Temperature2",
                                    right: `${_vm.calcT2(
                                      _vm.doubleR1,
                                      _vm.hubRightR2 / 1000
                                    )}°C`
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        !_vm.showInfoIfExistsR1
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "16px",
                                  "font-weight": "bold"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Please Read device to get base r\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                ])
              ])
            : _vm._e()
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selectModel === "Device",
              expression: "selectModel === 'Device'"
            }
          ],
          staticStyle: { "overflow-y": "auto" }
        },
        [
          _vm.loadDeviceSettingStatus === 1
            ? _c("div", [
                _vm.outputMode === 0 ||
                _vm.outputMode === 0x10 ||
                _vm.outputMode === 0x20
                  ? _c("div", [
                      _c("div", { staticClass: "info-item" }, [
                        _c("div", { staticClass: "info-title" }, [
                          _vm._v("Device Info")
                        ]),
                        _c("div", { staticClass: "item-split" }),
                        _c(
                          "div",
                          { staticClass: "info-content" },
                          [
                            _c("InfoRow", {
                              attrs: {
                                left: "Device Model",
                                right: _vm.insertDeviceName
                              }
                            }),
                            _c("InfoRow", {
                              attrs: { left: "ID", right: _vm.deviceIdentify }
                            }),
                            _vm.deviceType
                              ? _c("InfoRow", {
                                  attrs: {
                                    left: "Device Type",
                                    right: _vm.deviceType
                                  }
                                })
                              : _vm._e(),
                            _c("InfoRow", {
                              attrs: {
                                left: "Resistance",
                                right: `${_vm.resistance}Ω`
                              }
                            }),
                            _c("InfoRow", {
                              attrs: {
                                left: "Production Time",
                                right: _vm.productTime
                              }
                            }),
                            _c("InfoRow", {
                              attrs: { left: "Brand", right: _vm.brandName }
                            }),
                            _vm.supportOutputDuration
                              ? _c("InfoRow", {
                                  attrs: {
                                    left: "Output Duration",
                                    right: _vm.outputDuration
                                  }
                                })
                              : _vm._e(),
                            _vm.supportLevel
                              ? _c("InfoRow", {
                                  attrs: {
                                    left: "Level",
                                    right:
                                      _vm.writerSetting.touchSensitivity + 1
                                  }
                                })
                              : _vm._e(),
                            _vm.supportDoubleCartridge
                              ? _c("InfoRow", {
                                  attrs: {
                                    left: "Cartridge Mode",
                                    right: _vm.doubleCartridgeModeText
                                  }
                                })
                              : _vm._e(),
                            _vm.supportTripleCartridge
                              ? _c("InfoRow", {
                                  attrs: {
                                    left: "Cartridge Mode",
                                    right: _vm.tripleCartridgeModeText
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]),
                      false
                        ? _c("div", { staticClass: "info-item" }, [
                            _c(
                              "div",
                              { staticClass: "info-title" },
                              [
                                _vm._v(
                                  "\n              Preheat\n              "
                                ),
                                _c("van-switch", {
                                  staticStyle: { "margin-left": "auto" },
                                  attrs: {
                                    "active-color": "#66DCA5",
                                    "inactive-color": "#D6CDF2",
                                    size: "18",
                                    disabled: true
                                  },
                                  model: {
                                    value: _vm.writerSetting.isSupportPreheat,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.writerSetting,
                                        "isSupportPreheat",
                                        $$v
                                      )
                                    },
                                    expression: "writerSetting.isSupportPreheat"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("div", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.writerSetting.isSupportPreheat,
                                  expression: "writerSetting.isSupportPreheat"
                                }
                              ],
                              staticClass: "item-split"
                            }),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.writerSetting.isSupportPreheat,
                                    expression: "writerSetting.isSupportPreheat"
                                  }
                                ],
                                staticClass: "info-content"
                              },
                              [
                                _c("InfoRow", {
                                  attrs: {
                                    left: "Time",
                                    right: `${(
                                      _vm.writerSetting.preheatTime / 1000
                                    ).toFixed(1)}s`
                                  }
                                }),
                                _c("InfoRow", {
                                  attrs: {
                                    left: "Voltage",
                                    right: `${(
                                      _vm.writerSetting.preheatVoltage / 1000
                                    ).toFixed(1)}v`
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "info-item" }, [
                        _c("div", { staticClass: "info-title" }, [
                          _vm._v(_vm._s(_vm.curve1Title))
                        ]),
                        _c("div", { staticClass: "item-split" }),
                        _c("div", { staticClass: "info-content" }, [
                          _c(
                            "div",
                            { staticClass: "voltage-one" },
                            _vm._l(
                              _vm.doubleLeftCurveVoltage.slice(
                                0,
                                _vm.voltageCount
                              ),
                              function(item, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "voltage-number" },
                                  [
                                    _vm.outputMode === 0x20
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              Math.abs(item / 100).toFixed(1)
                                            ) + _vm._s(_vm.unitName)
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              Math.abs(item / 1000).toFixed(1)
                                            ) + _vm._s(_vm.unitName)
                                          )
                                        ])
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "voltage-two",
                              staticStyle: {
                                width: "100%",
                                height: "calc(20vh)"
                              }
                            },
                            _vm._l(
                              _vm.doubleLeftCurveVoltage.slice(
                                0,
                                _vm.voltageCount
                              ),
                              function(value, index) {
                                return _c("van-slider", {
                                  key: index,
                                  attrs: {
                                    vertical: "",
                                    min: _vm.dragValue.max,
                                    max: _vm.dragValue.min,
                                    step: _vm.dragValue.step,
                                    "bar-height": "4px",
                                    "active-color": "#EEEEEE",
                                    "inactive-color": "#D6CDF2",
                                    disabled: true
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button",
                                        fn: function() {
                                          return [
                                            _c("img", {
                                              staticClass: "slider-button",
                                              attrs: {
                                                src: require("@/assets/icons/icon_slider_button_disabled.png")
                                              }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.doubleLeftCurveVoltage[index],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.doubleLeftCurveVoltage,
                                        index,
                                        $$v
                                      )
                                    },
                                    expression: "doubleLeftCurveVoltage[index]"
                                  }
                                })
                              }
                            ),
                            1
                          ),
                          false
                            ? _c(
                                "div",
                                { staticClass: "voltage-three" },
                                _vm._l(_vm.voltageCount, function(index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "voltage-number"
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(index) +
                                          "s\n                "
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm.supportDoubleCartridge && _vm.isReadDoubleCartridgeMode
                  ? _c("div", { staticClass: "info-item" }, [
                      _c("div", { staticClass: "info-title" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.curve2Title) +
                            "\n          "
                        )
                      ]),
                      _c("div", { staticClass: "item-split" }),
                      _c("div", { staticClass: "info-content" }, [
                        _c(
                          "div",
                          { staticClass: "voltage-one" },
                          _vm._l(
                            _vm.doubleRightCurveVoltage.slice(
                              0,
                              _vm.voltageCount
                            ),
                            function(item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "voltage-number" },
                                [
                                  _vm.outputMode === 0x20
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              Math.abs(item / 100).toFixed(1)
                                            ) +
                                            _vm._s(_vm.unitName)
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            Math.abs(item / 1000).toFixed(1)
                                          ) + _vm._s(_vm.unitName)
                                        )
                                      ])
                                ]
                              )
                            }
                          ),
                          0
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "voltage-two",
                            staticStyle: { width: "100%", height: "calc(20vh)" }
                          },
                          _vm._l(
                            _vm.doubleRightCurveVoltage.slice(
                              0,
                              _vm.voltageCount
                            ),
                            function(value, index) {
                              return _c("van-slider", {
                                key: index,
                                attrs: {
                                  vertical: "",
                                  min: _vm.dragValue.max,
                                  max: _vm.dragValue.min,
                                  step: 100,
                                  "bar-height": "4px",
                                  "active-color": "#EEEEEE",
                                  "inactive-color": "#D6CDF2",
                                  disabled: true
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "button",
                                      fn: function() {
                                        return [
                                          _c("img", {
                                            staticClass: "slider-button",
                                            attrs: {
                                              src: require("@/assets/icons/icon_slider_button_disabled.png")
                                            }
                                          })
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.doubleRightCurveVoltage[index],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.doubleRightCurveVoltage,
                                      index,
                                      $$v
                                    )
                                  },
                                  expression: "doubleRightCurveVoltage[index]"
                                }
                              })
                            }
                          ),
                          1
                        ),
                        false
                          ? _c(
                              "div",
                              { staticClass: "voltage-three" },
                              _vm._l(_vm.voltageCount, function(index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "voltage-number" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(index) +
                                        "s\n              "
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ])
                    ])
                  : _vm.outputMode === 0x40
                  ? _c("div", { staticStyle: { "font-size": "14px" } }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("div", { staticClass: "info-title" }, [
                          _vm._v("\n              Device Info\n            ")
                        ]),
                        _c("div", { staticClass: "item-split" }),
                        _c(
                          "div",
                          { staticClass: "info-content" },
                          [
                            _c("InfoRow", {
                              attrs: {
                                left: "Device Model",
                                right: _vm.insertDeviceName
                              }
                            }),
                            _c("InfoRow", {
                              attrs: { left: "ID", right: _vm.deviceIdentify }
                            }),
                            _vm.deviceType
                              ? _c("InfoRow", {
                                  attrs: {
                                    left: "Device Type",
                                    right: _vm.deviceType
                                  }
                                })
                              : _vm._e(),
                            _c("InfoRow", {
                              attrs: {
                                left: "Resistance",
                                right: `${_vm.resistance}Ω`
                              }
                            }),
                            _c("InfoRow", {
                              attrs: {
                                left: "Production Time",
                                right: _vm.productTime
                              }
                            }),
                            _c("InfoRow", {
                              attrs: { left: "Brand", right: _vm.brandName }
                            })
                          ],
                          1
                        ),
                        _vm.supportTripleCartridge
                          ? _c(
                              "div",
                              { staticClass: "info-content" },
                              [
                                _c("InfoRow", {
                                  attrs: {
                                    left: "Push Power",
                                    right: `${_vm.writerSetting.micSensitivity.toFixed(
                                      2
                                    )}W`
                                  }
                                }),
                                _c("InfoRow", {
                                  attrs: {
                                    left: _vm.r1Title,
                                    right: `${_vm.r1}Ω`
                                  }
                                }),
                                _vm.showInfoIfExistsR1
                                  ? _c("InfoRow", {
                                      attrs: {
                                        left: _vm.r2Title,
                                        right: `${(
                                          _vm.deviceLeftR2 / 1000 +
                                          _vm.r1
                                        ).toFixed(3)}Ω`
                                      }
                                    })
                                  : _vm._e(),
                                _c("InfoRow", {
                                  attrs: {
                                    left: "Temperature",
                                    right: `${_vm.calcT2(
                                      _vm.r1,
                                      _vm.deviceLeftR2 / 1000
                                    )}°C`
                                  }
                                }),
                                _vm.showInfoIfExistsDoubleR1Triple
                                  ? _c("InfoRow", {
                                      attrs: {
                                        left: _vm.centerR1Title,
                                        right: `${_vm.centerR1}Ω`
                                      }
                                    })
                                  : _vm._e(),
                                _vm.showInfoIfExistsDoubleR1Triple
                                  ? _c("InfoRow", {
                                      attrs: {
                                        left: _vm.centerR2Title,
                                        right: `${(
                                          _vm.deviceTripleCenterR2 / 1000 +
                                          _vm.centerR1
                                        ).toFixed(3)}Ω`
                                      }
                                    })
                                  : _vm._e(),
                                _vm.showInfoIfExistsDoubleR1Triple
                                  ? _c("InfoRow", {
                                      attrs: {
                                        left: "Temperature",
                                        right: `${_vm.calcT2(
                                          _vm.centerR1,
                                          _vm.deviceTripleCenterR2 / 1000
                                        )}°C`
                                      }
                                    })
                                  : _vm._e(),
                                _vm.showInfoIfExistsDoubleR1Triple
                                  ? _c("InfoRow", {
                                      attrs: {
                                        left: _vm.doubleR1Title,
                                        right: `${_vm.rightR1}Ω`
                                      }
                                    })
                                  : _vm._e(),
                                _vm.showInfoIfExistsDoubleR1Triple
                                  ? _c("InfoRow", {
                                      attrs: {
                                        left: _vm.doubleR2Title,
                                        right: `${(
                                          _vm.deviceTripleRightR2 / 1000 +
                                          _vm.rightR1
                                        ).toFixed(3)}Ω`
                                      }
                                    })
                                  : _vm._e(),
                                _vm.showInfoIfExistsDoubleR1Triple
                                  ? _c("InfoRow", {
                                      attrs: {
                                        left: "Temperature",
                                        right: `${_vm.calcT2(
                                          _vm.rightR1,
                                          _vm.deviceTripleRightR2 / 1000
                                        )}°C`
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _c("div", [
                              _c(
                                "div",
                                { staticClass: "info-content" },
                                [
                                  _c("InfoRow", {
                                    attrs: {
                                      left: "Push Power",
                                      right: `${(
                                        _vm.writerSetting.diyVoltage[2] / 100
                                      ).toFixed(2)}W`
                                    }
                                  }),
                                  _c("InfoRow", {
                                    attrs: {
                                      left: _vm.r1Title,
                                      right: _vm.r1Value
                                    }
                                  }),
                                  _c("InfoRow", {
                                    attrs: {
                                      left: _vm.r2Title,
                                      right: `${(
                                        _vm.deviceLeftR2 / 1000 +
                                        _vm.r1
                                      ).toFixed(3)}Ω`
                                    }
                                  }),
                                  _c("InfoRow", {
                                    attrs: {
                                      left: "Temperature",
                                      right: `${_vm.calcT2(
                                        _vm.r1,
                                        _vm.deviceLeftR2 / 1000
                                      )}°C`
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm.supportDoubleCartridge
                                ? _c(
                                    "div",
                                    { staticClass: "info-content" },
                                    [
                                      _c("InfoRow", {
                                        attrs: {
                                          left: "Push Power",
                                          right: `${(
                                            _vm.writerSetting.diyVoltage[5] /
                                            100
                                          ).toFixed(2)}W`
                                        }
                                      }),
                                      _c("InfoRow", {
                                        attrs: {
                                          left: _vm.doubleR1Title,
                                          right: `${(
                                            _vm.writerSetting.touchSensitivity /
                                            100
                                          ).toFixed(3)}Ω`
                                        }
                                      }),
                                      _c("InfoRow", {
                                        attrs: {
                                          left: _vm.doubleR2Title,
                                          right: `${(
                                            _vm.deviceRightR2 / 1000 +
                                            _vm.doubleR1
                                          ).toFixed(3)}Ω`
                                        }
                                      }),
                                      _c("InfoRow", {
                                        attrs: {
                                          left: "Temperature",
                                          right: `${_vm.calcT2(
                                            _vm.doubleR1,
                                            _vm.deviceRightR2 / 1000
                                          )}°C`
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm.loadDeviceSettingStatus === 0
            ? _c("div", { staticClass: "error-info" }, [
                _c("div", { staticClass: "device-error-msg" }, [
                  _vm._v(_vm._s(_vm.errorMessage))
                ]),
                _c(
                  "div",
                  {
                    staticClass: "try-again",
                    on: { click: _vm.reloadDeviceSetting }
                  },
                  [_vm._v("\n          Try again\n        ")]
                )
              ])
            : _c(
                "div",
                { staticClass: "popup-content info-device-load" },
                [_c("van-loading", { attrs: { size: "60px" } })],
                1
              )
        ]
      )
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.selectModel === "Device" && this.loadDeviceSettingStatus == 1,
            expression:
              "selectModel === 'Device' && this.loadDeviceSettingStatus == 1"
          }
        ],
        staticClass: "footer"
      },
      [
        _c(
          "van-button",
          {
            staticClass: "footer-button",
            attrs: { type: "default" },
            on: { click: _vm.onClickApply }
          },
          [_vm._v("\n      Apply to homepage\n    ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }